// components/Auth/Login.js
import { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const { handleLogin } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await handleLogin(email, password);
      navigate("/documents");
    } catch (err) {
      setError("Błędny email lub hasło");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.bg}>
      <form onSubmit={onSubmit} style={styles.form} autoComplete="on" aria-label="Logowanie">
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <img src="/image.png" alt="Paperly logo" style={{ height: 25, width: 'auto', display: 'block' }} />
        </div>
        <h1 style={styles.title}>Zaloguj się</h1>
        <p style={styles.subtitle}>Witaj ponownie! Wprowadź swoje dane, aby uzyskać dostęp do panelu.</p>
        <div style={styles.inputGroup}>
          <label htmlFor="email" style={styles.label}>Email</label>
          <input
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="np. jan.kowalski@email.com"
            type="email"
            required
            style={styles.input}
            autoFocus
            autoComplete="email"
          />
        </div>
        <div style={styles.inputGroup}>
          <label htmlFor="password" style={styles.label}>Hasło</label>
          <input
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Twoje hasło"
            type="password"
            required
            style={styles.input}
            autoComplete="current-password"
          />
        </div>
        {error && <div style={styles.error}>{error}</div>}
        <button type="submit" style={styles.button} disabled={loading}>
          {loading ? "Logowanie..." : "Zaloguj się"}
        </button>
        <div style={styles.footer}>
          <span>Nie masz konta?</span>
          <a href="/register" style={styles.link}>Zarejestruj się</a>
        </div>
        <div style={styles.footer}>
          <a href="/reset-password" style={styles.link}>Nie pamiętasz hasła?</a>
        </div>
      </form>
    </div>
  );
}

const styles = {
  bg: {
    width: "100vw",
    height: "100vh",
    background: "linear-gradient(120deg, #4a90e2 0%, #14539a 100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 0,
    margin: 0,
    minHeight: "100vh",
    minWidth: "100vw",
    boxSizing: "border-box",
  },
  form: {
    background: "#fff",
    borderRadius: 16,
    boxShadow: "0 8px 32px rgba(44, 62, 80, 0.15)",
    padding: "40px 32px 32px 32px",
    minWidth: 320,
    maxWidth: 380,
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: 18,
    alignItems: "stretch",
  },
  title: {
    fontSize: 28,
    fontWeight: 700,
    color: "#14539a",
    marginBottom: 4,
    textAlign: "center",
    letterSpacing: 0.5,
  },
  subtitle: {
    fontSize: 15,
    color: "#4a90e2",
    marginBottom: 18,
    textAlign: "center",
  },
  inputGroup: {
    display: "flex",
    flexDirection: "column",
    gap: 6,
    marginBottom: 10,
  },
  label: {
    fontSize: 14,
    color: "#14539a",
    fontWeight: 500,
    marginBottom: 2,
  },
  input: {
    padding: "12px 14px",
    borderRadius: 8,
    border: "1px solid #dbeafe",
    fontSize: 15,
    outline: "none",
    transition: "border 0.2s",
    background: "#f8fafc",
    color: "#222",
    fontWeight: 400,
    boxSizing: "border-box",
  },
  error: {
    color: "#e74c3c",
    background: "#fbeaea",
    borderRadius: 8,
    padding: "8px 12px",
    marginBottom: 8,
    fontSize: 14,
    textAlign: "center",
  },
  button: {
    marginTop: 10,
    padding: "12px 0",
    borderRadius: 8,
    border: "none",
    background: "linear-gradient(90deg, #4a90e2 0%, #14539a 100%)",
    color: "#fff",
    fontWeight: 700,
    fontSize: 16,
    cursor: "pointer",
    boxShadow: "0 2px 8px rgba(44, 62, 80, 0.08)",
    transition: "background 0.2s, box-shadow 0.2s",
    letterSpacing: 0.5,
    outline: "none",
  },
  footer: {
    marginTop: 18,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: 6,
    fontSize: 14,
    color: "#888",
  },
  link: {
    color: "#4a90e2",
    textDecoration: "none",
    fontWeight: 600,
    marginLeft: 4,
    transition: "color 0.2s",
  },
};
